<div class="qa-fielded-resource">
  <ng-container [ngSwitch]="isClickable">
    <button
      *ngSwitchCase="true"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-controls]="ariaControlsId"
      [ngSwitch]="resource.part_of?.title ? true : false"
      (click)="resourceClicked.emit($event)"
      class="c-fielded-resource__expansion-button btn btn-link btn-link-xs user-select-auto qa-item__meta--fielded"
      type="button"
    >
      <span
        *ngSwitchCase="true"
        class="c-resource__field c-resource__field--title"
      >
        {{ resource.title }}
      </span>
      <cite *ngSwitchDefault class="c-resource__field c-resource__field--title">
        {{ resource.title }}
      </cite>
    </button>

    <span *ngSwitchDefault [ngSwitch]="resource.part_of?.title ? true : false">
      <span
        *ngSwitchCase="true"
        class="c-resource__field c-resource__field--title u-color-gray-base qa-item__meta--fielded"
      >
        {{ resource.title }}
      </span>
      <cite
        *ngSwitchDefault
        class="c-resource__field c-resource__field--title u-color-gray-base qa-item__meta--fielded"
      >
        {{ resource.title }}
      </cite>
    </span>
  </ng-container>

  <span
    *ngIf="resource.part_of?.title"
    class="c-resource__field c-resource__field--part-of"
    i18n="@@fieldedResource-label-inResource"
    >in
    <cite class="c-resource__field--part-of-title">{{
      resource.part_of.title
    }}</cite></span
  >
</div>

<ul class="list-unstyled u-mb0">
  <li
    *ngIf="resource.resource_type"
    class="c-resource__field c-resource__field--type"
  >
    <rl-bibliographic-resource-type [resourceType]="resource.resource_type">
    </rl-bibliographic-resource-type>
  </li>
  <li
    *ngIf="resource.authorNames?.length"
    class="c-resource__field c-resource__field--authors"
    i18n="@@fieldedResource-label-byAuthors"
  >
    by {{ resource.authorNames.join('; ') }}
  </li>
  <li
    *ngIf="resource.editorNames?.length && !resource.authorNames?.length"
    class="c-resource__field c-resource__field--editors"
    i18n="@@fieldedResource-label-byEditors"
  >
    edited by {{ resource.editorNames.join('; ') }}
  </li>

  <li
    *ngIf="resource.dates?.length"
    class="c-resource__field c-resource__field--date"
  >
    {{ resource.formattedDates.join('; ') }}
  </li>

  <li
    *ngIf="resource.edition"
    class="c-resource__field c-resource__field--edition"
  >
    {{ resource.edition }}
  </li>

  <ng-container [ngSwitch]="itemImportanceTemplate">
    <ng-container *ngSwitchCase="null">
      <li
        *ngIf="itemImportance?.description"
        class="c-resource__field c-resource__field--importance"
      >
        {{ itemImportance.description }}
      </li>
    </ng-container>

    <li
      *ngSwitchDefault
      class="c-resource__field c-resource__field--importance"
    >
      <ng-container [ngTemplateOutlet]="itemImportanceTemplate"></ng-container>
    </li>
  </ng-container>
</ul>
